<template>
    <div class="specific-tab">
        <div class="tabulation-title" :style="'color:' + titlesColor">
            <h5>
                {{ index }}. Informations spécifiques
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <form-component-loader :fields="tabulationFields"></form-component-loader>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import FormComponentLoader from "../FormComponentLoader.vue"

export default {
    name: "Specific",
    components: { FormComponentLoader },
    props: ['index'],
    computed: {
        ...mapState('webFormStyle', ['titlesColor']),
        ...mapState('web_form', ['provider']),
        ...mapGetters('web_form', ['getFieldsFromTabulation', 'getFamilyByCode']),
        tabulationFields() {
            let fields = this.getFieldsFromTabulation(this.provider.category.name).sort((a, b) => a.order - b.order)
            fields = fields.filter(field => field.fieldable.code !== 'DESC_PARTY_MENU' && field.fieldable.name !== 'Capacites')

            // écarte les champs de type select qui n'ont pas d'élément de ref e config
            fields = fields.filter(field =>  {
                if (field.fieldable_type === 'App\\Models\\Referential\\FamilyElement') {
                    const elements = this.getFamilyByCode(field.fieldable.name)

                    return elements.length > 0
                } else {
                    return field
                }
            })

            return fields
        }
    }
}
</script>